import { reportClientError } from './clientLog'

const _api = import.meta.env.VITE_API_BASE
export const API_BASE =
  _api !== undefined ? _api : import.meta.env.PROD ? '' : 'http://127.0.0.1:5055'

export function getToken(): string | null {
  return localStorage.getItem('mybonet_token')
}

export function setToken(token: string | null) {
  if (token) localStorage.setItem('mybonet_token', token)
  else localStorage.removeItem('mybonet_token')
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set('Content-Type', 'application/json')
  const token = getToken()
  if (token) headers.set('Authorization', `Bearer ${token}`)
  const res = await fetch(`${API_BASE}${path}`, { ...init, headers })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = (data as { error?: string }).error || res.statusText
    reportClientError(API_BASE, {
      message: err,
      source: 'app-platform',
      kind: 'api_error',
    })
    throw new Error(err)
  }
  return data as T
}

/** Form / client validation failures → NLog error. */
export function reportValidationError(message: string, fields?: Record<string, string>) {
  reportClientError(API_BASE, {
    message: fields ? `${message} ${JSON.stringify(fields)}` : message,
    source: 'app-platform',
    kind: 'validation',
  })
}
